import api from './api';

export const communityTestimonialService = {
  getPublic: async (limit = 6) => {
    const response = await api.get('/community-testimonials', { params: { limit } });
    return response.data?.data || [];
  },

  getMine: async () => {
    const response = await api.get('/community-testimonials/mine');
    return response.data?.data || [];
  },

  submit: async (payload) => {
    const { photo, ...fields } = payload || {};
    const hasPhoto = photo instanceof File;

    if (hasPhoto) {
      const formData = new FormData();
      Object.entries(fields).forEach(([key, value]) => {
        if (value !== undefined && value !== null) {
          formData.append(key, value);
        }
      });
      formData.append('photo', photo);
      const response = await api.post('/community-testimonials', formData);
      return response.data;
    }

    const response = await api.post('/community-testimonials', fields);
    return response.data;
  },
};
